import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { OfferSection } from '../components/sales/OfferSection';
import { SocialProofSection } from '../components/sales/SocialProofSection';
import { FAQSection } from '../components/sales/FAQSection';
import { CTASection } from '../components/sales/CTASection';
import { FooterSection } from '../components/sales/FooterSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream-DEFAULT overflow-x-hidden" data-id="element-269">
      <HeroSection data-id="element-270" />
      <ProblemSection data-id="element-271" />
      <MechanismSection data-id="element-272" />
      <SolutionSection data-id="element-273" />
      <SocialProofSection data-id="element-274" />
      <OfferSection data-id="element-275" />
      <FAQSection data-id="element-276" />
      <CTASection data-id="element-277" />
      <FooterSection data-id="element-278" />
    </main>;
}